import gql from 'graphql-tag';

export default gql`
  query getPaymentMethods{
    paymentMethods{
      payments{
        paymentType,
        default,
        paymentId
      }
    }
  }
`;
